import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueMoment from "vue-moment";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCreditCard,
  faPrint,
  faFileDownload,
  faArrowRight,
  faSpinner,
  faInfoCircle,
  faUndo,
  faMobileAlt,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import {
  faCcAmex,
  faCcVisa,
  faCcMastercard,
  faApple,
  faGoogle,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import App from "./App.vue";
import router from "./router";
import { humanize } from "./filters";

library.add(
  faCcAmex,
  faCcMastercard,
  faCcVisa,
  faCreditCard,
  faPrint,
  faFileDownload,
  faArrowRight,
  faSpinner,
  faInfoCircle,
  faUndo,
  faMobileAlt,
  faWallet,
  faApple,
  faGoogle
);

Vue.use(VueMoment);

const host = window.location.hostname;
let API_BASE_URL = "https://api.cabcard.services";
if (
  host.indexOf("localhost") !== -1 ||
  host.indexOf("staging") !== -1 ||
  host.indexOf("-stg") !== -1
) {
  API_BASE_URL = "https://api-staging.cabcard.services";
} else if (host.indexOf("sandbox") !== -1 || host.indexOf("-sbx") !== -1) {
  API_BASE_URL = "https://api-sandbox.cabcard.services";
}

const client = axios.create({ baseURL: API_BASE_URL });

Vue.use(VueAxios, {
  api: client,
});

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.filter("humanize", humanize);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
